import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { setIsWriterDeviationFeatured, setIsWriterDeviationMature, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, resetWriterPopup, publishWriterDeviation, setIsRedirecting, initialize } from './actions';
const defaultState = {
    isSubmitting: false,
    isRedirecting: false,
    deviationId: null,
    error: null,
    isFeatured: false,
    isMature: false
};
const actionHandlers = handleActions({
    [initialize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isFeatured: action.payload.isFeatured,
            isMature: action.payload.isMature
        }),
    [setIsWriterDeviationFeatured.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isFeatured: action.payload.isFeatured
        }),
    [setIsWriterDeviationMature.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isMature: action.payload.isMature
        }),
    [saveWriterDeviation.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true,
            error: null
        }),
    [publishWriterDeviation.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true,
            error: null
        }),
    [saveWriterDeviationSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: false,
            deviationId: action.payload.deviationId,
            error: null
        }),
    [saveWriterDeviationFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: false,
            error: action.payload.error
        }),
    [setIsRedirecting.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isRedirecting: action.payload.isRedirecting
        }),
    [resetWriterPopup.toString()]: ()=>defaultState
}, defaultState);
const reducers = {
    [reduxKey]: (state, action)=>actionHandlers(state, action) || state
};
export default reducers;
